module.exports = __webpack_public_path__ + "teqbahn-assets/media/slider_4_icon.034fe990.png";